module.exports = __webpack_public_path__ + "static/media/eco-gif.02ac6bfa.gif";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/eco-gif.gif
// module id = 297
// module chunks = 0